<script lang="ts">
	import md from '$lib/utils/md';
	import { getCopy } from '$lib/lang/copy.svelte';

	import Headline from '$lib/components/fragments/Headline.svelte';
	import Section from '$lib/components/fragments/Section.svelte';
	import Callout from '$lib/components/fragments/Callout.svelte';
	import Divider from '$lib/components/fragments/Divider.svelte';
	import NCDs from '$lib/components/charts/NCDChart.svelte';

	const copy = $derived(getCopy().global_shift);
</script>

<Section id="shifts" class="bg-cream text-black">
	<div class="content-well-sm">
		<Headline overline={copy.overline} title={copy.title} />
		<p class="body-1">{@html md(copy.copy_before)}</p>
	</div>

	<div class="content-well-sm">
		<p class="heading-5 text-blue-light spanned">{@html md(copy.ncd_chart.hed)}</p>
		<Divider class="my-4" />
		<div class="flex flex-col gap-1">
			<p class="microcopy-2 text-blue font-bold">{@html md(copy.ncd_chart.caption)}</p>
		</div>
	</div>

	<div class="content-well">
		<NCDs />
		<div class="content-well-sm mt-8">
			<p class="source text-gray-darker">{@html md(copy.ncd_chart.source)}</p>
		</div>
	</div>

	<div class="content-well-sm">
		<p class="body-1">{@html md(copy.copy_middle)}</p>
	</div>

	<Callout
		image={{
			src: 'globalShift.webp',
			alt: copy.callout.alt,
			classes: 'max-w-[250px] md:max-w-[300px] my-4'
		}}
	>
		<div class="heading-6 callout-content">
			{@html md(copy.callout.text)}
		</div>
		<a
			href={copy.callout.source.href}
			class="text-blue-light microcopy-2 mt-5 block text-center font-bold underline md:mt-10 md:text-left"
			>{copy.callout.source.label}</a
		>
	</Callout>

	<div class="content-well-sm">
		<p class="body-1">{@html md(copy.copy_after)}</p>
	</div>
</Section>

<style lang="postcss">
	@reference '$lib/styles/app.css';

	.spanned {
		:global(span) {
			@apply text-blue-dark;
		}
	}

	.callout-content {
		:global(.markdown) {
			@apply gap-2;
		}

		:global(span) {
			@apply text-blue heading-2;
		}
	}
</style>
